<template>
  <div>
    <div class="page-verify__frame-intro">
      <div class="container">
          <div class="row h-left-align">
            <div class="col-md-5 col-md-offset-1 col-xs-offset-0">
              <div class="page-verify__content-wrapper">
                <div class="row page-verify__header">
                  <div class="col-sm-2 col-xs-2 page-verify__header-image"><img width="45" src="/images/shield.png" /></div>
                  <div class="col-sm-9 col-xs-9 page-verify__header-text">Please create a password to begin using your member portal account.</div>
                </div>
                <div class="row page-verify__content">
                  <transition name="hint" appear>
                    <div class="row page-verify__password-reqs">
                      <div class="col-xs-4">
                        <h3 class="password-reqs__title">Requirements:</h3>
                      </div>
                      <div class="col-xs-8">
                        <div class="password-reqs__content" v-for="rule in rules" v-bind:key="rule.key" v-cloak>
                          <div class="password-reqs__icon h-display-inline-block">
                            <i class="fa fa-times-circle password-reqs__icon--valid" v-if="rule.valid"></i>
                            <i class="fa fa-check-circle password-reqs__icon--invalid" v-else></i>
                          </div>
                          <div class="password-reqs__error h-display-inline-block">{{rule.message}}</div>
                        </div>
                      </div>
                    </div>
                  </transition>
                </div>
              </div>
            </div>
            <div class="col-md-5">
              <div class="row">
                <div class="page-verify__form-container">
                  <div class="page-verify__form">
                    <div class="page-verify__form-item">
                      <div class="col-md-2 col-sm-1 col-xs-2 page-verify__icon text-right">
                        <i class="fa fa-envelope"></i>
                      </div>
                      <div class="form-group col-sm-10 col-xs-9">
                        <input
                          class="form-control page-verify__input"
                          type="email"
                          v-model="email"
                          readonly
                        />
                      </div>
                    </div>
                    <div class="page-verify__form-item">
                      <div class="col-md-2 col-sm-1 col-xs-2 page-verify__icon text-right">
                        <i class="fa fa-lock"></i>
                      </div>
                      <div class="form-group col-sm-10 col-xs-9">
                        <input
                            class="form-control page-verify__input"
                            placeholder="password"
                            data-placeholder="password"
                            v-model="password"
                            :class="{valid:isPasswordValid}"
                            type="password"
                            autocomplete="new-password"
                        />
                      </div>
                    </div>
                    <div class="page-verify__form-item">
                      <div class="col-md-2 col-sm-1 col-xs-2 page-verify__icon text-right">
                        <i class="fa fa-lock"></i>
                      </div>
                      <div class="form-group col-sm-10 col-xs-9">
                        <input
                            class="form-control page-verify__input"
                            placeholder="confirm password"
                            data-placeholder="confirm password"
                            v-model="password2"
                            :class="{valid:isPasswordValid}"
                            type="password"
                            autocomplete="new-password"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row text-center">
            <div class="col">
              <button
                  type="button"
                  class="page-login__login-btn"
                  :disabled="!isPasswordValid"
                  @click.prevent="verify"
              >Verify Your Account</button>
            </div>
          </div>
          <div class="row text-center">
            <div class="col">
              <router-link to="reset" class="page-login__trouble-link">Return to Login</router-link>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
  import lodash from 'lodash';
  import { mapGetters } from 'vuex';

  export default {
    name: 'VerifyForm',
    mounted() {
      this.verification_code = this.$route.query.code;
      this.$store.dispatch('auth/validateVerifyCode', { verification_code: this.verification_code })
      .then(() => {
        this.$store.dispatch('main/setProperty', { key: 'globalLoading', value: false });
      })
      .catch(() => {
        this.$router.push({ name: 'reset' });
      });
    },
    data() {
      return {
        error: null,
        password: null,
        password2: null,
        content: null,
        rules: [
          {
            key: 0,
            message: 'One lowercase letter',
            criteria: { regex: /[a-z]+/ },
            valid: false,
          },
          {
            key: 1,
            message: 'One uppercase letter',
            criteria: { regex: /[A-Z]+/ },
            valid: false,
          },
          {
            key: 2,
            message: '8 characters minimum',
            criteria: { regex: /.{8,}/ },
            valid: false,
          },
          {
            key: 3,
            message: 'One number required',
            criteria: { regex: /[0-9]+/ },
            valid: false,
          },
          {
            key: 4,
            message: 'Passwords must match',
            criteria: { matchPassword: true },
            valid: false,
          },
        ],
      };
    },
    computed: {
      ...mapGetters('auth', ['email', 'userId']),
      passwordsMatch() {
        return this.password !== '' && this.password === this.password2;
      },
      isPasswordValid() {
        return lodash.filter(this.rules, rule => !rule.valid).length === 0;
      },
    },
    watch: {
      password() {
        this.passwordValidation();
      },
      password2() {
        this.passwordValidation();
      },
    },
    methods: {
      verify() {
        this.$store.dispatch('main/setProperty', { key: 'globalLoading', value: true });
        this.$store.dispatch('auth/verify', {
          verification_code: this.verification_code,
          user_id: this.userId,
          email: this.email,
          password: this.password,
          password2: this.password2,
        })
          .then(() => {
            this.$router.push({ name: 'dashboard' });
          })
          .catch(err => {
            this.$router.push({ name: 'reset' });
          })
      },
      passwordValidation() {
        lodash.map(this.rules, (rule) => {
          rule.valid = this.runRuleCriteria(rule.criteria);
        });
      },
      runRuleCriteria(criteria) {
        if (criteria.hasOwnProperty('regex')) {
          return criteria.regex.test(this.password);
        }
        if (criteria.hasOwnProperty('matchPassword')) {
          return this.passwordsMatch;
        }
        return false;
      },
    },
  }
</script>
